<div class="wrapper">
  <!-- Chọn ngôn ngữ -->
  <div class="mb-3">
    <app-select-language-config [isAdmin]="true"></app-select-language-config>
  </div>
  <div class="main-menu" style="margin-top: 10px;">
    <!-- Sửa sub-menu -->
    <div class="select-link-page">
     <div class="content-right">
      <!-- Danh sách loại link -->
      <nz-radio-group nzName="radiogroup" 
        [(ngModel)]="data.childMenu.type"
        (ngModelChange)="onChangeAttr()">
        <label nz-radio *ngFor="let link of listLink" [nzValue]="link.url">{{link.name | translate}}</label>
      </nz-radio-group>
      <!-- Tên menu con -->
      <div class="fill-name-menu">
        <p class="title-name">{{'ten_menu_con' | translate}}: </p>
        <input nz-input placeholder="{{'nhap_ten_menu_con' | translate}}"
          [(ngModel)]="data.childMenu['name_' + functionService.selectedLanguageCode]"
          (input)="onChangeAttr()" />
      </div>
      <!-- Chọn liên kết loại Không (none) -->
      <div class="connect-page" *ngIf="data.childMenu.type == 'none'"> 
      </div>
      <!-- Chọn liên kết loại Đến trang (link-page) -->
      <div class="connect-page" *ngIf="data.childMenu.type == 'link-page'">
        <!-- Trang liên kết -->
        <div class="fill-name-menu">
          <p class="title-name">{{'trang_lien_ket' | translate}}: </p>
          <div class="elementor-select">
            <nz-select nzAllowClear class="field-fill" style="width:100%"
              [nzPlaceHolder]="data.childMenu.link_page ? data.childMenu.link_page : ('chon_trang_lien_ket' | translate)"
              [(ngModel)]="data.childMenu.link_page"
              (ngModelChange)="onChangeAttr()">
              <nz-option *ngFor="let page of listLinkPage"
                [nzValue]="page._id || ''"
                [nzLabel]="page.name | translate"></nz-option>
            </nz-select>
          </div>
        </div>
      </div>
      <!-- Liên kết website -->
      <div class="connect-page" *ngIf="data.childMenu.type == 'website'">
        <div class="fill-name-menu">
          <p class="title-name">{{'lien_ket_website' | translate}}: </p>
          <div class="elementor-select">
            <input nz-input class="field-fill" placeholder="{{'nhap_duong_dan' | translate}}"
              style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;"
              [(ngModel)]="data.childMenu.link_website"
              (input)="onChangeAttr()"  />
          </div>
        </div>
      </div>
      <!-- Chọn liên kết loại URL (link-url) -->
      <div class="connect-page" *ngIf="data.childMenu.type == 'link-url'">
        <!-- Link sản phẩm -->
        <div class="fill-name-menu">
          <p class="title-name">{{'link_san_pham'}}: </p>
          <div class="elementor-select">
            <input nz-input class="field-fill" placeholder="/ten-trang-chi-tiet-san-pham/ten-san-pham"
              style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;"
              [(ngModel)]="data.childMenu.link_url"
              (input)="onChangeAttr()" />
          </div>
        </div>
      </div>

      <div class="fill-name-menu" *ngIf="data.childMenu.type != 'none'">
        <p class="title-name">{{'hanh_dong_khi_nhan' | translate}}:</p>
        <div class="elementor-select">
            <nz-select nzAllowClear class="field-fill" style="width:100%"
                [nzPlaceHolder]="'cuon_len_dau_trang' | translate"
                [(ngModel)]="data.childMenu.is_scroll"
                (ngModelChange)="onChangeAttr()">
                <nz-option [nzLabel]="'cuon_len_dau_trang' | translate" [nzValue]="true"></nz-option>
                <nz-option [nzLabel]="'giu_nguyen_vi_tri' | translate" [nzValue]="false"></nz-option>
            </nz-select>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
<div class="action"
style="display:flex;align-items:center;justify-content: flex-end;gap: 5px;margin-top: 15px">
<button nz-button style="margin-left: 10px;" (click)="cancelFormEditSub()">{{'huy' | translate}}</button>
<button nz-button nzType="primary" [disabled]="!isValid" (click)="saveValueDataEdit()">{{'luu' | translate}}</button>
</div>